import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function CashMin(props) {
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [rows, setRows] = useState([]);
    const [minData, setminData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        fetchData();
    }, [selectedDate]);
    useEffect(() => {
        if (minData.length > 0) {
            setRows(minData);
        }
    }, [minData]);
    function fetchData() {
        setIsLoading(true);
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        axios.get(`${baseUrl}min-pay-view/${formattedDate}/`)
            .then(response => {
                setminData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const handleDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setSelectedDate(localDate);
    };
    const columns = [
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'pat__patient', headerName: 'Patient', width: 200},
        {field: 'min_test', headerName: 'Test Name', width: 400},
        {field: 'addedby', headerName: 'Added by', width: 100},
        {field: 'min_amount', headerName: 'Amount', width: 100},
        {field: 'min_tot', headerName: 'Total', width: 100},
        {
            field: 'action', headerName: 'Action',
            renderCell: (params) => (
                <Link to={`/min-pay/${params.row.appt_id}`} className="btn btn-success">
                    Pay
                </Link>
            ),
            width: 100
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="dd/MM/yyyy"/>
                        </div>
                    </div>
                </div>
            </div>

            {!isLoading && minData.length > 0 ? (
                <div style={{height: "100%", width: "100%"}} className="mt-4">
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={rows}
                              columns={columns}
                              pageSize={10}
                              slots={{toolbar: GridToolbar}}
                              autoHeight
                    />
                </div>
            ) : (
                <></>
            )}
        </section>
    )
}
export default CashMin;
